export default __webpack_public_path__ + "assets/fa9e81301bde1481e16b7c39d9a5856e.jpeg";